import { getSortFields } from 'apps/auth/components/form-multi/utils';
import { NAME } from 'apps/auth/constants/fieldsName';

export const getRegistrationFields = (registrationFields = [], step = 0) => {
    const fields = registrationFields[step];
    return fields ? getSortFields(fields) : [];
};
export const hasFilledPersonalInfo = (currentFields = [], fields = []) => {
    if (currentFields.length > 0) {
        let fieldsWithValue = 0;
        const nameField = currentFields.find((f) => f?.name === NAME);
        if (!!nameField) {
            currentFields.forEach((f) => {
                const field = fields[f.name];
                if (field?.value) {
                    fieldsWithValue = fieldsWithValue + 1;
                }
            });
        }
        return currentFields.length === fieldsWithValue;
    } else {
        return false;
    }
};
